var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "m--margin-left-10 icon-bade-block" }, [
    _c("i", { staticClass: "m--font-success", class: _vm.icon }),
    _vm._v(" "),
    _c("span", { staticClass: "icon-bade-block__subtitle" }, [
      _vm._v("\n    " + _vm._s(_vm.$t(_vm.header)) + "\n  "),
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "icon-bade-block__desc" }, [
      _vm._v("\n    " + _vm._s(_vm.$t(_vm.description)) + "\n  "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }